import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto bg-white p-8 rounded-2xl border border-gray-200" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-gray-800 mb-6" }, "Öğretmen Listesi", -1)
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_6 = { class: "text-gray-600" }
const _hoisted_7 = { class: "text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teachers, (teacher) => {
          return (_openBlock(), _createElementBlock("li", {
            key: teacher.name,
            class: "flex justify-between items-center bg-gray-50 p-4 rounded-lg border"
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(teacher.name), 1),
              _createElementVNode("p", _hoisted_6, "Eğitim Yılı: " + _toDisplayString(teacher.year), 1),
              _createElementVNode("p", _hoisted_7, "Branş: " + _toDisplayString(teacher.subject), 1)
            ]),
            _createVNode(_component_router_link, {
              to: "/okul/isik",
              class: "bg-gray-900 text-white py-2 px-4 rounded-lg hover:bg-gray-600 transition duration-300"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Görüşme Başlat ")
              ]),
              _: 1
            })
          ]))
        }), 128))
      ])
    ])
  ]))
}